// extracted by mini-css-extract-plugin
export default {"link":"RouteButton_link__KFXxX"};